import React from "react";

import classes from "./Header.module.css";

export default function UserProfile() {
  return (
    <div className={classes.SignInButton}>
      <div className={classes.ProfileIcon}>
        <i className="fas fa-user" />
      </div>
      <span>SIGN IN</span>
    </div>
  );
}
